// 下载文件
import BaseURL from "./BaseURL";

/**
 * 从后端下载文件
 * @param {string} filename - 要下载的文件名（如 "line_chart_1758069829609.html"）
 */
export const downloadFile = async (filename) => {
  try {
    const response = await BaseURL.get('api/file/download/', {
      params: { filename }, // 👈 通过 query 参数传递文件名
      responseType: 'blob', // 👈 关键：必须设置为 blob
    });
    
    // 下载的文件名
    const htmlfileName = filename;

    // 创建 blob 对象
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // 创建临时链接并触发下载
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', htmlfileName); // 设置下载文件名
    document.body.appendChild(link);
    link.click();

    // 清理：释放内存
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true; // 下载成功
  } catch (error) {
    console.error('下载失败:', error);

    if (error.response?.status === 404) {
      alert('文件不存在，请重试或联系管理员。');
    } else if (error.response?.status === 400) {
      alert('无效的文件请求。');
    } else if (error.request) {
      // 网络问题（如连接超时、证书错误）
      alert('网络连接失败，请检查后端服务是否正常运行。');
    } else {
      alert('下载失败，请稍后再试。');
    }

    return false;
  }
};